import React from 'react';
import styled from 'styled-components';
import Color from '../../enums/color';
import ThreeDots from './ThreeDots';
const LoadingContainer = styled.div `
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
const Loading = () => (<LoadingContainer>
    <ThreeDots color={Color.CobaltBlue}/>
  </LoadingContainer>);
export default Loading;
